import { dataDaSlashaDash } from 'app/utility/dataOra';
import { RefertoContext } from 'app/context/RefertoContext';
import React, { useContext, useState } from 'react';
import { NotificationManager, NotificationContainer } from "react-notifications";

const StoriaClinica = ({ onClose, onCancel }) => {
  const defaultState = {
    anamnesiPatologica: '',
    dataInizio: '',
    dataFine: '',
    diagnosi: '',
    cronicita: '',
    cronicitaLabel: '',
    statoClinico: '',
    statoClinicoLabel: '',
    descrizioneStato: '',
  };

  const { state: referto, dispatch: dispatchReferto } = useContext(RefertoContext);
  const storiaClinica = referto?.storiaClinica || defaultState;
  // Elaborazione dei dati iniziali, processando anche le date e i label
  const processedInitialData = {
    ...storiaClinica,
    dataInizio: storiaClinica?.dataInizio ? dataDaSlashaDash(storiaClinica.dataInizio) : '',
    dataFine: storiaClinica?.dataFine ? dataDaSlashaDash(storiaClinica.dataFine) : '',
    cronicitaLabel:
      storiaClinica?.cronicita === 'LA28752-6'
        ? 'Cronico'
        : storiaClinica?.cronicita === 'LA18821-1'
          ? 'Acuto'
          : '',
    statoClinicoLabel:
      storiaClinica?.statoClinico === 'LA16666-2'
        ? 'Attivo'
        : storiaClinica?.statoClinico === 'LA18632-2'
          ? 'Inattivo'
          : '',
  };

  const [bindData, setBindData] = useState(processedInitialData || defaultState);
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedFields = { [name]: value };

    switch (name) {
      case 'cronicita':
        updatedFields.cronicitaLabel =
          value === 'LA28752-6'
            ? 'Cronico'
            : value === 'LA18821-1'
              ? 'Acuto'
              : '';
        break;
      case 'statoClinico':
        updatedFields.statoClinicoLabel =
          value === 'LA16666-2'
            ? 'Attivo'
            : value === 'LA18632-2'
              ? 'Inattivo'
              : '';
        break;
      default:
        break;
    }

    setBindData((prev) => ({
      ...prev,
      ...updatedFields,
    }));
  };

  const validateForm = () => {
    const newErrors = {};

    if (!bindData.anamnesiPatologica) {
      newErrors.anamnesiPatologica =
        "Il campo 'Anamnesi patologica' è obbligatorio.";
    }
    if (!bindData.dataInizio) {
      newErrors.dataInizio = "Il campo 'Data inizio' è obbligatorio.";
    }
    if (bindData.dataFine && bindData.dataFine < bindData.dataInizio) {
      newErrors.dataFine =
        "La data di fine non può essere precedente alla data di inizio.";
    }
    if (!bindData.diagnosi) {
      newErrors.diagnosi = "Il campo 'Diagnosi' è obbligatorio.";
    }
    if (!bindData.descrizioneStato) {
      newErrors.descrizioneStato =
        "Il campo 'Descrizione stato' è obbligatorio.";
    }
    if (!bindData.statoClinico) {
      newErrors.statoClinico =
        "Il campo 'Stato clinico' è obbligatorio.";
    }
    if (!bindData.cronicita) {
      newErrors.cronicita = "Il campo 'Cronicità' è obbligatorio.";
    }

    return newErrors;
  };

  const handleSubmit = (e) => {
    NotificationManager.listNotify.forEach(n => NotificationManager.remove({ id: n.id }));
    e.preventDefault();
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    dispatchReferto({
      type: "UPDATE_FIELD",
      field: "storiaClinica",
      payload: bindData
    });

    NotificationManager.success("Salvataggio avvenuto con successo", "Salva");
    setErrors({});
    if (onClose) {
      onClose();
    }
  };

  const handleCancella = () => {
    setBindData(defaultState);
    dispatchReferto({
      type: "UPDATE_FIELD",
      field: "storiaClinica",
      payload: defaultState
    });
    setErrors({});
    if (onCancel) {
      onCancel();
    }
  };

  return (
    <form className='container' onSubmit={handleSubmit}>
      <div className="form-group">
        <label>Anamnesi patologica, fisiologica</label>
        <textarea
          name="anamnesiPatologica"
          autoComplete="off"
          className={`form-control ${errors.anamnesiPatologica ? 'is-invalid' : ''
            }`}
          value={bindData.anamnesiPatologica}
          onChange={handleChange}
        />
        {errors.anamnesiPatologica && (
          <div className="invalid-feedback">
            {errors.anamnesiPatologica}
          </div>
        )}
      </div>

      <div className="row">
        <div className="form-group col-md-6">
          <label>Data inizio</label>
          <input
            type="date"
            name="dataInizio"
            autoComplete="off"
            className={`form-control ${errors.dataInizio ? 'is-invalid' : ''
              }`}
            value={bindData.dataInizio}
            onChange={handleChange}
          />
          {errors.dataInizio && (
            <div className="invalid-feedback">{errors.dataInizio}</div>
          )}
        </div>
        <div className="form-group col-md-6">
          <label>Data fine</label>
          <input
            type="date"
            name="dataFine"
            autoComplete="off"
            className={`form-control ${errors.dataFine ? 'is-invalid' : ''}`}
            value={bindData.dataFine}
            onChange={handleChange}
          />
          {errors.dataFine && (
            <div className="invalid-feedback">{errors.dataFine}</div>
          )}
        </div>
      </div>

      <div className="form-group">
        <label>Diagnosi</label>
        <textarea
          name="diagnosi"
          autoComplete="off"
          className={`form-control ${errors.diagnosi ? 'is-invalid' : ''}`}
          value={bindData.diagnosi}
          onChange={handleChange}
        />
        {errors.diagnosi && (
          <div className="invalid-feedback">{errors.diagnosi}</div>
        )}
      </div>

      <div className="row">
        <div className="form-group col-md-6">
          <label>Cronicità della patologia</label>
          <select
            name="cronicita"
            className={`form-control ${errors.cronicita ? 'is-invalid' : ''}`}
            value={bindData.cronicita}
            onChange={handleChange}
          >
            <option value="">Seleziona</option>
            <option value="LA28752-6">Cronico</option>
            <option value="LA18821-1">Acuto</option>
          </select>
          {errors.cronicita && (
            <div className="invalid-feedback">{errors.cronicita}</div>
          )}
        </div>
        <div className="form-group col-md-6">
          <label>Stato clinico</label>
          <select
            name="statoClinico"
            className={`form-control ${errors.statoClinico ? 'is-invalid' : ''}`}
            value={bindData.statoClinico}
            onChange={handleChange}
          >
            <option value="">Seleziona</option>
            <option value="LA16666-2">Attivo</option>
            <option value="LA18632-2">Inattivo</option>
          </select>
          {errors.statoClinico && (
            <div className="invalid-feedback">{errors.statoClinico}</div>
          )}
        </div>
      </div>

      <div className="form-group">
        <label>Descrizione stato</label>
        <textarea
          name="descrizioneStato"
          autoComplete="off"
          className={`form-control ${errors.descrizioneStato ? 'is-invalid' : ''
            }`}
          value={bindData.descrizioneStato}
          onChange={handleChange}
        />
        {errors.descrizioneStato && (
          <div className="invalid-feedback">{errors.descrizioneStato}</div>
        )}
      </div>

      <div className="mt-3 d-flex justify-content-between">
        <button type="submit" className="btn btn-primary">
          Conferma
        </button>
        <button
          type="button"
          className="btn btn-danger text-white"
          onClick={handleCancella}
        >
          Cancella
        </button>
      </div>
      <NotificationContainer />
    </form>
  );
};

export default StoriaClinica;
